export default [
	{
		name: 'Played First Game',
		category: 'Overall',
		title: 'Let the Games Begin',
		description: 'Played First Game',
		image: 'ace',
		points: '25',
		pushToFacebook: 'true',
		order: '1',
		check: (p) => (p?.stats?.['You']?.['All']?.played_match?.count > 0),
	},

	// {
	// 	name: '5 Easy Wins',
	// 	category: 'Easy',
	// 	title: 'Piece of Cake',
	// 	description: 'Win 5 matches on Easy',
	// 	image: 'cake-slice',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '2',
	// 	check: (p) => p['win_Easy'] >= 5,
	// },
	// {
	// 	name: '5 Medium Wins',
	// 	category: 'Medium',
	// 	title: 'Made Flight',
	// 	description: 'Win 5 matches on Medium',
	// 	image: 'butterfly',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '3',
	// 	check: (p) => p['win_Medium'] >= 5,
	// },
	// {
	// 	name: '10 Medium Wins',
	// 	category: 'Medium',
	// 	title: 'Quick Flyer',
	// 	description: 'Win 10 matches on Medium',
	// 	image: 'dragonfly',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '4',
	// 	check: (p) => p['win_Medium'] >= 10,
	// },
	// {
	// 	name: '20 Medium Wins',
	// 	category: 'Medium',
	// 	title: 'Growing Force',
	// 	description: 'Win 20 matches on Medium',
	// 	image: 'bee',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '5',
	// 	check: (p) => p['win_Medium'] >= 20,
	// },
	// {
	// 	name: '50 Medium Wins',
	// 	category: 'Medium',
	// 	title: 'Little Fighter',
	// 	description: 'Win 50 matches on Medium',
	// 	image: 'wasp-sting',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '6',
	// 	check: (p) => p['win_Medium'] >= 50,
	// },
	// {
	// 	name: '100 Medium Wins',
	// 	category: 'Medium',
	// 	title: 'Little Champion ',
	// 	description: 'Win 100 matches on Medium',
	// 	image: 'scarab-beetle',
	// 	points: '70',
	// 	pushToFacebook: 'true',
	// 	order: '7',
	// 	check: (p) => p['win_Medium'] >= 100,
	// },
	// {
	// 	name: '5 Hard Wins',
	// 	category: 'Hard',
	// 	title: 'Got Your Feet Wet',
	// 	description: 'Win 5 matches on Hard',
	// 	image: 'ammonite',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '9',
	// 	check: (p) => p['win_Hard'] >= 5,
	// },
	// {
	// 	name: '10 Hard Wins',
	// 	category: 'Hard',
	// 	title: 'Neigh to Losing',
	// 	description: 'Win 10 matches on Hard',
	// 	image: 'horse-head',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '10',
	// 	check: (p) => p['win_Hard'] >= 10,
	// },
	// {
	// 	name: '20 Hard Wins',
	// 	category: 'Hard',
	// 	title: 'Hard to Beat',
	// 	description: 'Win 20 matches on Hard',
	// 	image: 'turtle',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '11',
	// 	check: (p) => p['win_Hard'] >= 20,
	// },
	// {
	// 	name: '50 Hard Wins',
	// 	category: 'Hard',
	// 	title: 'Fast And Silent',
	// 	description: 'Win 50 matches on Hard',
	// 	image: 'frog',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '12',
	// 	check: (p) => p['win_Hard'] >= 50,
	// },
	// {
	// 	name: '100 Hard Wins',
	// 	category: 'Hard',
	// 	title: 'Choice Fish',
	// 	description: 'Win 100 matches on Hard',
	// 	image: 'angler-fish',
	// 	points: '70',
	// 	pushToFacebook: 'true',
	// 	order: '13',
	// 	check: (p) => p['win_Hard'] >= 100,
	// },
	// {
	// 	name: '5 Crazy Ninja Wins',
	// 	category: 'CrazyNinja',
	// 	title: 'Ninja Has Awaken',
	// 	description: 'Win 5 matches on CrazyNinja',
	// 	image: 'sleepy',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '14',
	// 	check: (p) => p['win_CrazyNinja'] >= 5,
	// },
	// {
	// 	name: '10 Crazy Ninja Wins',
	// 	category: 'CrazyNinja',
	// 	title: 'Sparing Partner',
	// 	description: 'Win 10 matches on CrazyNinja',
	// 	image: 'ninja-mask',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '15',
	// 	check: (p) => p['win_CrazyNinja'] >= 10,
	// },
	// {
	// 	name: '20 Crazy Ninja Wins',
	// 	category: 'CrazyNinja',
	// 	title: 'Black Belt',
	// 	description: 'Win 20 matches on CrazyNinja',
	// 	image: 'iron-mask',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '16',
	// 	check: (p) => p['win_CrazyNinja'] >= 20,
	// },
	// {
	// 	name: '50 Crazy Ninja Wins',
	// 	category: 'CrazyNinja',
	// 	title: 'Merciless',
	// 	description: 'Win 50 matches on CrazyNinja',
	// 	image: 'tear-tracks',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '17',
	// 	check: (p) => p['win_CrazyNinja'] >= 50,
	// },
	// {
	// 	name: '100 Crazy Ninja Wins',
	// 	category: 'CrazyNinja',
	// 	title: 'Ninja Destroyer',
	// 	description: 'Win 100 matches on CrazyNinja',
	// 	image: 'pummeled',
	// 	points: '70',
	// 	pushToFacebook: 'true',
	// 	order: '18',
	// 	check: (p) => p['win_CrazyNinja'] >= 100,
	// },
	// {
	//     "name": "1 Insane Monkey Win",
	//     "category": "Insane Monkey",
	//     "title": "Distinguished Warrior",
	//     "description": "Win 1 match on Insane Monkey",
	//     "image": "monkey",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "121",
	//     "check": function (p) { return p["win_InsaneMonkey"] >= 1 }
	// },
	// {
	//     "name": "5 Insane Monkey Wins",
	//     "category": "Insane Monkey",
	//     "title": "Monkey Dominator",
	//     "description": "Win 5 matches on Insane Monkey",
	//     "image": "totem-head",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "122",
	//     "check": function (p) { return p["win_InsaneMonkey"] >= 5 }
	// },
	// {
	//     "name": "20 Insane Monkey Wins",
	//     "category": "Insane Monkey",
	//     "title": "Monkey Dominator",
	//     "description": "Win 20 matches on Insane Monkey",
	//     "image": "totem-head",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "122",
	//     "check": function (p) { return p["win_InsaneMonkey"] >= 20 }
	// },
	// {
	//     "name": "1 UltraCheetah Win",
	//     "category": "UltraCheetah",
	//     "title": "Hello Cheetah",
	//     "description": "Win 1 match on UltraCheetah",
	//     "image": "anthem",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "121",
	//     "check": function (p) { return p["win_UltraCheetah"] >= 1 }
	// },
	// {
	//     "name": "10 UltraCheetah Wins",
	//     "category": "UltraCheetah",
	//     "title": "Speed Cheetah",
	//     "description": "Win 10 matches on UltraCheetah",
	//     "image": "anthem",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "122",
	//     "check": function (p) { return p["win_UltraCheetah"] >= 10 }
	// },
	// {
	//     "name": "30 UltraCheetah Wins",
	//     "category": "UltraCheetah",
	//     "title": "Cheetah Dominator",
	//     "description": "Win 30 matches on UltraCheetah",
	//     "image": "energy-arrow",
	//     "points": "100",
	//     "pushToFacebook": "true",
	//     "order": "122",
	//     "check": function (p) { return p["win_UltraCheetah"] >= 30 }
	// },
	// {
	//     "name": "1 Impossible Win",
	//     "category": "Impossible",
	//     "title": "Impossible Path",
	//     "description": "Win 1 match on Impossible",
	//     "image": "evil-tree",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "121",
	//     "check": function (p) { return p["win_Impossible"] >= 1 }
	// },
	// {
	//     "name": "10 Impossible Wins",
	//     "category": "Impossible",
	//     "title": "Impossible Boom",
	//     "description": "Win 10 matches on Impossible",
	//     "image": "explosive-materials",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "122",
	//     "check": function (p) { return p["win_Impossible"] >= 10 }
	// },
	// {
	//     "name": "30 Impossible Wins",
	//     "category": "Impossible",
	//     "title": "Not Possible",
	//     "description": "Win 30 matches on Impossible",
	//     "image": "extra-lucid",
	//     "points": "100",
	//     "pushToFacebook": "true",
	//     "order": "122",
	//     "check": function (p) { return p["win_Impossible"] >= 30 }
	// },
	{
		name: '1 Win',
		category: 'Overall',
		title: 'Reached Baby-Noob Status',
		description: 'Win 1 match',
		image: 'mouse',
		points: '25',
		pushToFacebook: 'true',
		order: '18',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 1),
	},
	{
		name: '5 Wins',
		category: 'Overall',
		title: 'Reached Noob Status',
		description: 'Win 5 matches',
		image: 'mouse',
		points: '25',
		pushToFacebook: 'true',
		order: '19',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 5),
	},
	{
		name: '10 Wins',
		category: 'Overall',
		title: 'Reached Noob+ Status',
		description: 'Win 10 matches',
		image: 'mouse',
		points: '25',
		pushToFacebook: 'true',
		order: '19',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 10),
	},
	{
		name: '20 Wins',
		category: 'Overall',
		title: 'Small Beginnings ',
		description: 'Win 20 matches',
		image: 'mouse',
		points: '50',
		pushToFacebook: 'true',
		order: '20',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 20),
	},
	{
		name: '30 Wins',
		category: 'Overall',
		title: 'Consistent Flyer',
		description: 'Win 30 matches',
		image: 'bird-twitter',
		points: '100',
		pushToFacebook: 'true',
		order: '21',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 30),
	},
	{
		name: '50 Wins',
		category: 'Overall',
		title: 'Quiet Potential',
		description: 'Win 50 matches',
		image: 'cat',
		points: '150',
		pushToFacebook: 'true',
		order: '22',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 50),
	},
	{
		name: '75 Wins',
		category: 'Overall',
		title: 'Dangerous Foe',
		description: 'Win 75 matches',
		image: 'scorpion',
		points: '200',
		pushToFacebook: 'true',
		order: '23',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 75),
	},
	{
		name: '100 Wins',
		category: 'Overall',
		title: 'Slippery Predator ',
		description: 'Win 100 matches',
		image: 'squid',
		points: '200',
		pushToFacebook: 'true',
		order: '24',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 100),
	},
	{
		name: '150 Wins',
		category: 'Overall',
		title: 'Power Player',
		description: 'Win 150 matches',
		image: 'hound',
		points: '250',
		pushToFacebook: 'true',
		order: '25',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 150),
	},
	{
		name: '200 Wins',
		category: 'Overall',
		title: 'Quick and Formidable',
		description: 'Win 200 matches',
		image: 'lion',
		points: '300',
		pushToFacebook: 'true',
		order: '26',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 200),
	},
	{
		name: '250 Wins',
		category: 'Overall',
		title: 'Unstoppable Force',
		description: 'Win 250 matches',
		image: 'croc-jaws',
		points: '300',
		pushToFacebook: 'true',
		order: '27',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 250),
	},
	{
		name: '300 Wins',
		category: 'Overall',
		title: "It's Dinomight!",
		description: 'Win 300 matches',
		image: 'dinosaur-rex',
		points: '300',
		pushToFacebook: 'true',
		order: '28',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.sum >= 300),
	},
	// {
	// 	name: '600 Wins',
	// 	category: 'Overall',
	// 	title: 'Soaring Above The Competition',
	// 	description: 'Win 600 matches',
	// 	image: 'eagle-emblem',
	// 	points: '500',
	// 	pushToFacebook: 'true',
	// 	order: '29',
	// 	check: (p) => (p?.win >= 600),
	// },
	// {
	//     "name": "1500 Wins",
	//     "category": "Overall",
	//     "title": "King of Cards",
	//     "description": "Win 1500 matches",
	//     "image": "king",
	//     "points": "1000",
	//     "pushToFacebook": "true",
	//     "order": "30",
	//     "check": function (p) { return p["win"] >= 1500 }
	// }, {
	//     "name": "2000 Wins",
	//     "category": "Overall",
	//     "title": "King of Cards",
	//     "description": "Win 2000 matches",
	//     "image": "king",
	//     "points": "1500",
	//     "pushToFacebook": "true",
	//     "order": "30",
	//     "check": function (p) { return p["win"] >= 2000 }
	// },
	{
		name: 'Win 3 times in a row',
		category: 'All',
		title: 'Dominator',
		description: 'Win 3 times in a row',
		image: 'palm',
		points: '25',
		pushToFacebook: 'true',
		order: '31',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.streakMax >= 3),
	},
	// {
	// 	name: 'Win Medium 3 times in a row',
	// 	category: 'Medium',
	// 	title: 'Dominator',
	// 	description: 'Win Medium 3 times in a row',
	// 	image: 'palm',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '32',
	// 	check: (p) => p['win_streak_Medium'] >= 3,
	// },
	// {
	// 	name: 'Win Hard 3 times in a row',
	// 	category: 'Hard',
	// 	title: 'Dominator',
	// 	description: 'Win Hard 3 times in a row',
	// 	image: 'palm',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '33',
	// 	check: (p) => p['win_streak_Hard'] >= 3,
	// },
	// {
	// 	name: 'Win Crazy Ninja 3 times in a row',
	// 	category: 'CrazyNinja',
	// 	title: 'Dominator',
	// 	description: 'Win Crazy Ninja 3 times in a row',
	// 	image: 'palm',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '34',
	// 	check: (p) => p['win_streak_CrazyNinja'] >= 3,
	// },
	{
		name: 'Win 5 times in a row',
		category: 'All',
		title: 'On Fire',
		description: 'Win 5 times in a row',
		image: 'paw',
		points: '25',
		pushToFacebook: 'true',
		order: '35',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.streakMax >= 5),
	},
	// {
	// 	name: 'Win Medium 5 times in a row',
	// 	category: 'All',
	// 	title: 'On Fire',
	// 	description: 'Win Medium 7 times in a row',
	// 	image: 'paw',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '36',
	// 	check: (p) => p['win_streak_Medium'] >= 5,
	// },
	// {
	// 	name: 'Win Hard 5 times in a row',
	// 	category: 'All',
	// 	title: 'On Fire',
	// 	description: 'Win Hard 5 times in a row',
	// 	image: 'paw',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '37',
	// 	check: (p) => p['win_streak_Hard'] >= 5,
	// },
	// {
	// 	name: 'Win Crazy Ninja 5 times in a row',
	// 	category: 'CrazyNinja',
	// 	title: 'On Fire',
	// 	description: 'Win Crazy Ninja 5 times in a row',
	// 	image: 'paw',
	// 	points: '25',
	// 	pushToFacebook: 'true',
	// 	order: '38',
	// 	check: (p) => p['win_streak_CrazyNinja'] >= 5,
	// },
	{
		name: 'Win 7 times in a row',
		category: 'All',
		title: 'Overkill',
		description: 'Win 7 times in a row',
		image: 'flaming-claw',
		points: '50',
		pushToFacebook: 'true',
		order: '39',
		check: (p) => (p?.stats?.['You']?.['All']?.win?.streakMax >= 7),
	},
	// {
	// 	name: 'Win Crazy Ninja 7 times in a row',
	// 	category: 'CrazyNinja',
	// 	title: 'Overkill',
	// 	description: 'Win Crazy Ninja 7 times in a row',
	// 	image: 'flaming-claw',
	// 	points: '50',
	// 	pushToFacebook: 'true',
	// 	order: '40',
	// 	check: (p) => p['win_streak_CrazyNinja'] >= 7,
	// },
	// {
	//     "name": "Tie Hard 1 time",
	//     "category": "Hard",
	//     "title": "Peacemaker",
	//     "description": "Tie Hard 1 time",
	//     "image": "meditation",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "55",
	//     "check": function (p) { return p["tie_Hard"] >= 1 }
	// },
	// {
	//     "name": "Tie Crazy Ninja 1 time",
	//     "category": "CrazyNinja",
	//     "title": "Peacemaker",
	//     "description": "Tie Crazy Ninja 1 time",
	//     "image": "meditation",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "56",
	//     "check": function (p) { return p["tie_CrazyNinja"] >= 1 }
	// },

	// {
	//     "name": "5 Online Wins",
	//     "category": "Online",
	//     "title": "Online Noobie",
	//     "description": "Win 5 matches Online",
	//     "image": "duality",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "106",
	//     "check": function (p) { return p["win_Online"] >= 5 }
	// },
	// {
	//     "name": "10 Online Wins",
	//     "category": "Online",
	//     "title": "Meeting the Competition",
	//     "description": "Win 10 matches Online",
	//     "image": "duality",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "107",
	//     "check": function (p) { return p["win_Online"] >= 10 }
	// },
	// {
	//     "name": "20 Online Wins",
	//     "category": "Online",
	//     "title": "Beating the Competition",
	//     "description": "Win 20 matches Online",
	//     "image": "backup",
	//     "points": "40",
	//     "pushToFacebook": "true",
	//     "order": "108",
	//     "check": function (p) { return p["win_Online"] >= 20 }
	// },
	// {
	//     "name": "50 Online Wins",
	//     "category": "Online",
	//     "title": "Plays To Win",
	//     "description": "Win 50 matches Online",
	//     "image": "backup",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "109",
	//     "check": function (p) { return p["win_Online"] >= 50 }
	// },
	// {
	//     "name": "100 Online Wins",
	//     "category": "Online",
	//     "title": "Wifi Junkie",
	//     "description": "Win 100 matches Online",
	//     "image": "dark-squad",
	//     "points": "100",
	//     "pushToFacebook": "true",
	//     "order": "110",
	//     "check": function (p) { return p["win_Online"] >= 100 }
	// },
	// {
	//     "name": "500 Online Wins",
	//     "category": "Online",
	//     "title": "Online Legend",
	//     "description": "Win 500 matches Online",
	//     "image": "dozen",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "111",
	//     "check": function (p) { return p["win_Online"] >= 500 }
	// },
	{
		name: '5 Losses',
		category: 'Overall',
		title: 'Thunder Struck',
		description: 'Lose 5 matches',
		image: 'dozen',
		points: '25',
		pushToFacebook: 'true',
		order: '112',
		check: (p) => (p?.stats?.['You']?.['All']?.loss?.sum >= 5),
	},
	{
		name: '10 Losses',
		category: 'Overall',
		title: 'Thunder Struck',
		description: 'Lose 10 matches',
		image: 'thunder-struck',
		points: '25',
		pushToFacebook: 'true',
		order: '112',
		check: (p) => (p?.stats?.['You']?.['All']?.loss?.sum >= 10),
	},
	{
		name: '20 Losses',
		category: 'Overall',
		title: 'Eaten Right Up',
		description: 'Lose 20 matches',
		image: 'fishbone',
		points: '25',
		pushToFacebook: 'true',
		order: '113',
		check: (p) => (p?.stats?.['You']?.['All']?.loss?.sum >= 20),
	},
	{
		name: '30 Losses',
		category: 'Overall',
		title: 'Swimming in Dangerous Waters',
		description: 'Lose 30 matches',
		image: 'shark-jaws',
		points: '25',
		pushToFacebook: 'true',
		order: '114',
		check: (p) => (p?.stats?.['You']?.['All']?.loss?.sum >= 30),
	},
	{
		name: 'First Moon Shot',
		category: 'Overall',
		title: 'One Moon',
		description: 'First Moon Shot',
		image: 'moon',
		points: '25',
		pushToFacebook: 'true',
		order: '120',
		check: (p) => (p?.stats?.['You']?.['All']?.moon_shots?.sum >= 1),
	},
	{
		name: 'Moon Shot x5',
		category: 'Overall',
		title: 'Moons x5',
		description: 'Five Moon Shots',
		image: 'moon',
		points: '25',
		pushToFacebook: 'true',
		order: '120',
		check: (p) => (p?.stats?.['You']?.['All']?.moon_shots?.sum >= 5),
	},
	{
		name: 'Moon Shot x10',
		category: 'Overall',
		title: 'Moons + Moons',
		description: 'Ten Moon Shots',
		image: 'moon',
		points: '25',
		pushToFacebook: 'true',
		order: '120',
		check: (p) => (p?.stats?.['You']?.['All']?.moon_shots?.sum >= 10),
	},
	{
		name: 'Zero Point Round x5',
		category: 'Easy',
		title: 'Zero Points',
		description: 'Finish 5 rounds with zero points',
		image: 'tyre',
		points: '25',
		pushToFacebook: 'true',
		order: '121',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_round?.sum >= 5),
	},
	{
		name: 'Zero Point Round x20',
		category: 'Easy',
		title: 'Zero Points x20',
		description: 'Finish 20 rounds with zero points',
		image: 'tyre',
		points: '25',
		pushToFacebook: 'true',
		order: '122',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_round?.sum >= 20),
	},
	{
		name: 'Zero Point Round x50',
		category: 'Medium',
		title: 'Zero Points x50',
		description: 'Finish 50 rounds with zero points',
		image: 'tyre',
		points: '25',
		pushToFacebook: 'true',
		order: '123',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_round?.sum >= 50),
	},
	{
		name: 'Zero Point Round x100',
		category: 'Medium',
		title: 'Zero Points x100',
		description: 'Finish 100 rounds with zero points',
		image: 'tyre',
		points: '25',
		pushToFacebook: 'true',
		order: '124',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_round?.sum >= 100),
	},
	{
		name: 'Zero Point Match',
		category: 'Easy',
		title: 'Zero Point Match',
		description: 'Finish a Match with zero points',
		image: 'apple-seeds',
		points: '25',
		pushToFacebook: 'true',
		order: '125',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_match?.sum >= 1),
	},
	{
		name: 'Zero Point Match x5',
		category: 'Easy',
		title: 'Zero Point Match x5',
		description: 'Finish 5 Matches with zero points',
		image: 'apple-seeds',
		points: '25',
		pushToFacebook: 'true',
		order: '126',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_match?.sum >= 5),
	},
	{
		name: 'Zero Point Match x10',
		category: 'Hard',
		title: 'Zero Point Match x10',
		description: 'Finish 10 Matches with zero points',
		image: 'apple-seeds',
		points: '25',
		pushToFacebook: 'true',
		order: '127',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_match?.sum >= 10),
	},
	{
		name: 'Zero Point Match x20',
		category: 'Hard',
		title: 'Zero Point Match x20',
		description: 'Finish 20 Matches with zero points',
		image: 'apple-seeds',
		points: '25',
		pushToFacebook: 'true',
		order: '128',
		isHidden: 'true',
		check: (p) => (p?.stats?.['You']?.['All']?.zero_points_match?.sum >= 20),
	},
	// {
	//     "name": "400 Losses",
	//     "category": "Overall",
	//     "title": "Burned",
	//     "description": "Lose 400 matches",
	//     "image": "salamander",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "115",
	//     "check": function (p) { return p["lose"] > 400 }
	// },
	// {
	//     "name": "500 Losses",
	//     "category": "Overall",
	//     "title": "Determined to The End",
	//     "description": "Lose 500 matches",
	//     "image": "animal-skull",
	//     "points": "25",
	//     "pushToFacebook": "true",
	//     "order": "116",
	//     "check": function (p) { return p["lose"] > 500 }
	// },

	// {
	//     "name": "10 Insane Monkey Losses",
	//     "category": "Insane Monkey",
	//     "title": "Monkey Fighter",
	//     "description": "Lose 10 matches on Insane Monkey",
	//     "image": "monkey",
	//     "points": "50",
	//     "pushToFacebook": "true",
	//     "order": "123",
	//     "check": function (p) { return p["lose_InsaneMonkey"] >= 10 }
	// },
	{
		name: 'Bob lose',
		category: 'Easy',
		title: 'Bob lost',
		description: 'Bob loses a game',
		image: 'totem-head',
		points: '10',
		order: '100',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.sum >= 1),
	},
	{
		name: 'Bob lose 3',
		category: 'Easy',
		title: 'Bob Loses Again',
		description: 'Bob loses 3 games',
		image: 'totem-head',
		points: '10',
		order: '100',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.sum >= 2),
	},
	{
		name: 'Bob loses 5',
		category: 'Easy',
		title: 'Bob Loses Again and Again',
		description: 'Bob loses 5 games',
		image: 'totem-head',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.sum >= 5),
	},
	{
		name: 'Bob loses 10',
		category: 'Easy',
		title: 'Bob Loses Again and Again and Again',
		description: 'Bob loses 10 games',
		image: 'totem-head',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.sum >= 10),
	},
	{
		name: 'Bob never wins',
		category: 'Easy',
		title: 'Bob Never Wins',
		description: 'Bob loses 20 games',
		image: 'terror',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.sum >= 20),
	},
	{
		name: 'Bob losing streak',
		category: 'Easy',
		title: 'Bob Loss Streak',
		description: 'Bob loses 3 games in a row',
		image: 'tear-tracks',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.streakMax >= 3),
	},
	{
		name: 'Bob losing streak 5',
		category: 'Easy',
		title: 'Bob Losing Streak 5',
		description: 'Bob loses 5 games in a row',
		image: 'tear-tracks',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.streakMax >= 5),
	},
	{
		name: 'Bob is mad',
		category: 'Easy',
		title: 'Bob is Mad',
		description: 'Bob loses 7 games in a row',
		image: 'stomp',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.loss?.streakMax >= 7),
	},
	{
		name: 'Bob is happy',
		category: 'Easy',
		title: 'Bob is Happy',
		description: 'Bob wins 3 games in a row',
		image: 'tribal-mask',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.win?.streakMax >= 3),
	},
	{
		name: 'Bob is happier',
		category: 'Easy',
		title: 'Bob is Happier',
		description: 'Bob wins 5 games in a row',
		image: 'tribal-mask',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.win?.streakMax >= 5),
	},
	{
		name: 'Bob is king',
		category: 'Easy',
		title: 'Bob is King',
		description: 'Bob wins 7 games in a row',
		image: 'king',
		points: '25',
		order: '101',
		check: (p) => (p?.stats?.['Bob']?.['All']?.win?.streakMax >= 7),
	},
	{
		name: 'Rate Game',
		category: 'Other',
		title: 'Courteous Citizen',
		description: 'Rate the game',
		image: 'paw-heart',
		points: '25',
		order: '117',
	},
	//    ,
	//{
	//    "name": "Invite Facebook Friend",
	//    "category": "Online",
	//    "title": "Get The Party Started",
	//    "description": "Invite a facebook friend",
	//    "image": "minions",
	//    "points": "25",
	//    "order": "120"
	//}, 
	{
		name: 'See More Games',
		category: 'Other',
		title: 'Dora The Explorer',
		description: 'See More Games',
		image: 'heart-inside',
		points: '25',
		order: '118',
	},
	// {
	//     "name": "Steam Game",
	//     "category": "Other",
	//     "title": "Steam Game Open",
	//     "description": "Welcom to Steam!",
	//     "image": "heart-inside",
	//     "points": "1500",
	//     "order": "125",
	//     "isHidden": "true",
	//     "check": function (p) { return p["platform"] === "Steam" }
	// },

	//{
	//    "name": "Play Bluetooth Game",
	//    "category": "Online",
	//    "title": "Close Combat",
	//    "description": "Play a bluetooth game",
	//    "image": "telepathy",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "119"
	//    },
	{
		name: 'titleTapped10',
		category: 'Easy',
		title: 'Title Tapper',
		description: 'Tap the title 10 times',
		image: 'wildfires',
		points: '50',
		item: 'CribbageBoardGuitar',
		order: '1',
		check: (p) => p?.stats?.['titleTapped'] >= 10,
	},

];
